import { JOBS as JOBS_URL } from '~~/common/js/constants/urls';

export default () => {
  /* eslint-disable-next-line no-console */
  console.log(`
oooooooooooo                               o8o
\`888'     \`8                               \`"'
 888          .ooooo.   .ooooo.   .oooo.o oooo   .oooo.
 888oooo8    d88' \`"Y8 d88' \`88b d88(  "8 \`888  \`P  )88b
 888    "    888       888   888 \`"Y88b.   888   .oP"888
 888       o 888   .o8 888   888 o.  )88b  888  d8(  888
o888ooooood8 \`Y8bod8P' \`Y8bod8P' 8""888P' o888o \`Y888""8o

We love JavaScript too - why not code and plant trees? Check out ${JOBS_URL}

`);
};
